"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductListEdit = void 0;
var _zod = require("@hookform/resolvers/zod");
var _reactHookForm = require("react-hook-form");
var _personalProductListEditContext = require("../../contexts/personalProductListEditContext");
var _useSavePersonalProductList = require("../../hooks/useSavePersonalProductList");
var _components = require("./components");
var _ActionButtons = require("./components/ActionButtons");
var _ManagementToolbar = require("./components/ManagementToolbar");
var _ProductNameInput = require("./components/ProductNameInput/ProductNameInput");
var _Products = require("./components/Products");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const ProductListEdit = ()=>{
    const { personalProductListDetail: productList } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const { onSave, isLoading } = (0, _useSavePersonalProductList.useSavePersonalProductList)();
    const { productListEditValidationSchema } = (0, _utils.useProductListEditValidationSchema)();
    var _productList_name;
    const form = (0, _reactHookForm.useForm)({
        defaultValues: {
            name: (_productList_name = productList === null || productList === void 0 ? void 0 : productList.name) !== null && _productList_name !== void 0 ? _productList_name : ''
        },
        resolver: (0, _zod.zodResolver)(productListEditValidationSchema)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.MaximumRecordsReachedDialog, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.AddProduct, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
                ...form,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
                    noValidate: true,
                    onSubmit: form.handleSubmit(onSave),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.EditRoot, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ManagementToolbar.ManagementToolbar, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProductNameInput.ProductNameInput, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Products.Products, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ActionButtons.ActionButtons, {
                                isSaving: isLoading
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.ProductListEdit = ProductListEdit;
